import styled from "@emotion/styled";
import {  Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGFrequentlyQnA {
  is_active: boolean;
}

const ProductSGRecommendedShop: FC<ProductSGFrequentlyQnA> = ({ is_active }) => {
  return (
 
    <FormWrapper>
      <Form.Item
        label="คำถาม–คำตอบ (FAQ)"
        name="sg_frequently_qna"
        //rules={[{ required: is_active, message: "กรุณากรอกคำถามที่พบบ่อยเกี่ยวกับสินค้า" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}

      >
        <TextArea  placeholder="คำถาม–คำตอบ (FAQ) ขจัดข้อโต้แย้งของลูกค้า" showCount maxLength={5000}  rows={10} />
      </Form.Item>
    </FormWrapper>

  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง "คำถามที่พบบ่อยเกี่ยวกับสินค้า"</h6>
      <p style={{ color: "black" }}>
        Q : การเก็บและดูแลรักษา
        </p>
      <p style={{ color: "black",marginBottom: "10px" }}>
        A : การเก็บรักษาเก็บในอุณหภูมิที่เย็น ร้อนไม่เกิน 30 องศา เนื่องจากเกลือจะเปลี่ยนรูปและเสื่อมคุณภาพ
      </p>
      <p style={{ color: "black" }}>
        Q : อายุของสินค้า
        </p>
      <p style={{ color: "black" }}>
      A : อายุของสินค้านับจากวันที่ผลิตจะอยู่ได้ 1 ปี ในอุณหภูมิที่แนะนำ
      </p>
      <p style={{ color: "black" }}>
        Q : เปรียบเทียบกับสินค้าคู่แข่ง
        </p>
      <p style={{ color: "black" }}>
      A : สินค้าคู่แข่งในตลาดจะมีความบริสุทธิ์ของแร่ธาตุ
ที่จำเป็นอยู่ที่ 87.75% เทียบกับสินค้าของเราอยู่ที่ 99.5% เราจะมีปริมาณสูงที่สุดในตลาดปัจจุบัน
      </p>
      <p style={{ color: "black",fontWeight: "bold" }}>
        การขจัดข้อโต้แย้ง
        </p>
      <p style={{ color: "black" }}>
        Q : มีสินค้าที่ใช้อยู่แล้วยี่ห้อ XXX
        </p>
      <p style={{ color: "black" }}>
      A : สินค้า XXX มีราคาแพงถ้าเทียบกับการซื้อแบบ โหลของสินค้าเรา แถมสินค้ายังมีความบริสุทธิ์ของ แร่ธาตุสูงที่สุดในตลาด ลูกค้าต้องชอบ
      </p>
      <p style={{ color: "black" }}>
        Q : ไม่เอา กลัวไม่มาส่งอีก และสั่งปริมาณน้อย
        </p>
      <p style={{ color: "black" }}>
      A : เราจะมีการส่งหลายร้านค้าในเส้นทางนี้ เราจะมาทุกวันพุธและศุกร์ (ให้แนะนำวันที่จะผ่าน) สั่งน้อยเราก็มาส่ง เพราะรวม Order หลายๆ ร้านสามารถมาส่งได้
      </p>


    </div>
  );
};


export default ProductSGRecommendedShop;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
